// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)
import store from './store'
import axios from 'axios'

Vue.use(Vuetify, {
  theme: {
    primary: '#ed79ac', // #E53935
    info: '#a6d7b8',
    accent: '#F8F8F8'
  }
})


window.axios = axios;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created() {
    router.afterEach((to, from) => {
      let options = {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic'
      };

      this.$vuetify.goTo(Number(0), options);
    });
  }
})



// WEBPACK FOOTER //
// ./src/main.js